/**
 * Transaction Price Confirm Route - React Router v7
 * Route: /transaction/price/confirm
 */
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, no-console */
import type {LoaderFunctionArgs} from 'react-router-dom'
import {redirect, useLoaderData} from 'react-router-dom'

import {getInitialProps} from './getInitialProps.js'
import PriceConfirm from './index.js'

import './styles/index.scss'

export async function loader({context, request}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const pathname = url.pathname.endsWith('/') ? url.pathname : `${url.pathname}/`
  const query: Record<string, string> = {}
  url.searchParams.forEach((value, key) => {
    query[key] = value
  })
  const routeInfo = {location: {pathname, search: url.search, query}}

  try {
    const initialProps = await getInitialProps({routeInfo, context})
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const httpRedirect = (initialProps as any)?.__HTTP__?.redirectTo
    if (httpRedirect) throw redirect(httpRedirect)
    return {...initialProps, __RR7__: true}
  } catch (error: unknown) {
    if (error instanceof Response) throw error
    console.error('[RR7] PriceConfirm loader error:', error)
    throw error
  }
}

export function Component() {
  const data = useLoaderData()
  return <PriceConfirm {...data} />
}

Component.displayName = 'TransactionPriceConfirmRoute'
